export default __webpack_public_path__ + "static/media/3334 utensils side.62ee20a1.png";